// this file is generated by tasks/compile-countries.mjs
export const countries = [
    {
        iso: 'AF',
        phoneCode: '+93',
        de: 'Afghanistan',
    },
    {
        iso: 'EG',
        phoneCode: '+20',
        de: 'Ägypten',
    },
    {
        iso: 'AX',
        phoneCode: '+358',
        de: 'Åland',
    },
    {
        iso: 'AL',
        phoneCode: '+355',
        de: 'Albanien',
    },
    {
        iso: 'DZ',
        phoneCode: '+213',
        de: 'Algerien',
    },
    {
        iso: 'AS',
        phoneCode: '+1',
        de: 'Amerikanisch-Samoa',
    },
    {
        iso: 'VI',
        phoneCode: '+1',
        de: 'Amerikanische Jungferninseln',
    },
    {
        iso: 'AD',
        phoneCode: '+376',
        de: 'Andorra',
    },
    {
        iso: 'AO',
        phoneCode: '+244',
        de: 'Angola',
    },
    {
        iso: 'AI',
        phoneCode: '+1',
        de: 'Anguilla',
    },
    {
        iso: 'AG',
        phoneCode: '+1',
        de: 'Antigua und Barbuda',
    },
    {
        iso: 'GQ',
        phoneCode: '+240',
        de: 'Äquatorialguinea',
    },
    {
        iso: 'AR',
        phoneCode: '+54',
        de: 'Argentinien',
    },
    {
        iso: 'AM',
        phoneCode: '+374',
        de: 'Armenien',
    },
    {
        iso: 'AW',
        phoneCode: '+297',
        de: 'Aruba',
    },
    {
        iso: 'AC',
        phoneCode: '+247',
        de: 'Ascension',
    },
    {
        iso: 'AZ',
        phoneCode: '+994',
        de: 'Aserbaidschan',
    },
    {
        iso: 'ET',
        phoneCode: '+251',
        de: 'Äthiopien',
    },
    {
        iso: 'AU',
        phoneCode: '+61',
        de: 'Australien',
    },
    {
        iso: 'BS',
        phoneCode: '+1',
        de: 'Bahamas',
    },
    {
        iso: 'BH',
        phoneCode: '+973',
        de: 'Bahrain',
    },
    {
        iso: 'BD',
        phoneCode: '+880',
        de: 'Bangladesch',
    },
    {
        iso: 'BB',
        phoneCode: '+1',
        de: 'Barbados',
    },
    {
        iso: 'BY',
        phoneCode: '+375',
        de: 'Belarus',
    },
    {
        iso: 'BE',
        phoneCode: '+32',
        de: 'Belgien',
    },
    {
        iso: 'BZ',
        phoneCode: '+501',
        de: 'Belize',
    },
    {
        iso: 'BJ',
        phoneCode: '+229',
        de: 'Benin',
    },
    {
        iso: 'BM',
        phoneCode: '+1',
        de: 'Bermuda',
    },
    {
        iso: 'BT',
        phoneCode: '+975',
        de: 'Bhutan',
    },
    {
        iso: 'BO',
        phoneCode: '+591',
        de: 'Bolivien',
    },
    {
        iso: 'BQ',
        phoneCode: '+599',
        de: 'Bonaire, Saba und Sint Eustatius',
    },
    {
        iso: 'BA',
        phoneCode: '+387',
        de: 'Bosnien und Herzegowina',
    },
    {
        iso: 'BW',
        phoneCode: '+267',
        de: 'Botswana',
    },
    {
        iso: 'BR',
        phoneCode: '+55',
        de: 'Brasilien',
    },
    {
        iso: 'VG',
        phoneCode: '+1',
        de: 'Britische Jungferninseln',
    },
    {
        iso: 'IO',
        phoneCode: '+246',
        de: 'Britisches Territorium im Indischen Ozean',
    },
    {
        iso: 'BN',
        phoneCode: '+673',
        de: 'Brunei',
    },
    {
        iso: 'BG',
        phoneCode: '+359',
        de: 'Bulgarien',
    },
    {
        iso: 'BF',
        phoneCode: '+226',
        de: 'Burkina Faso',
    },
    {
        iso: 'BI',
        phoneCode: '+257',
        de: 'Burundi',
    },
    {
        iso: 'CL',
        phoneCode: '+56',
        de: 'Chile',
    },
    {
        iso: 'CK',
        phoneCode: '+682',
        de: 'Cookinseln',
    },
    {
        iso: 'CR',
        phoneCode: '+506',
        de: 'Costa Rica',
    },
    {
        iso: 'CW',
        phoneCode: '+599',
        de: 'Curaçao',
    },
    {
        iso: 'DK',
        phoneCode: '+45',
        de: 'Dänemark',
    },
    {
        iso: 'CD',
        phoneCode: '+243',
        de: 'Demokratische Republik Kongo',
    },
    {
        iso: 'DE',
        phoneCode: '+49',
        de: 'Deutschland',
    },
    {
        iso: 'DM',
        phoneCode: '+1',
        de: 'Dominica',
    },
    {
        iso: 'DO',
        phoneCode: '+1',
        de: 'Dominikanische Republik',
    },
    {
        iso: 'DJ',
        phoneCode: '+253',
        de: 'Dschibuti',
    },
    {
        iso: 'EC',
        phoneCode: '+593',
        de: 'Ecuador',
    },
    {
        iso: 'SV',
        phoneCode: '+503',
        de: 'El Salvador',
    },
    {
        iso: 'CI',
        phoneCode: '+225',
        de: "Elfenbeinküste (Côte d'Ivoire)",
    },
    {
        iso: 'ER',
        phoneCode: '+291',
        de: 'Eritrea',
    },
    {
        iso: 'EE',
        phoneCode: '+372',
        de: 'Estland',
    },
    {
        iso: 'SZ',
        phoneCode: '+268',
        de: 'Eswatini',
    },
    {
        iso: 'FK',
        phoneCode: '+500',
        de: 'Falklandinseln',
    },
    {
        iso: 'FO',
        phoneCode: '+298',
        de: 'Färöer',
    },
    {
        iso: 'FJ',
        phoneCode: '+679',
        de: 'Fidschi',
    },
    {
        iso: 'FI',
        phoneCode: '+358',
        de: 'Finnland',
    },
    {
        iso: 'FM',
        phoneCode: '+691',
        de: 'Föderierte Staaten von Mikronesien',
    },
    {
        iso: 'FR',
        phoneCode: '+33',
        de: 'Frankreich',
    },
    {
        iso: 'GF',
        phoneCode: '+594',
        de: 'Französisch-Guayana',
    },
    {
        iso: 'PF',
        phoneCode: '+689',
        de: 'Französisch-Polynesien',
    },
    {
        iso: 'GA',
        phoneCode: '+241',
        de: 'Gabun',
    },
    {
        iso: 'GM',
        phoneCode: '+220',
        de: 'Gambia',
    },
    {
        iso: 'GE',
        phoneCode: '+995',
        de: 'Georgien (ohne Abchasien)',
    },
    {
        iso: 'GH',
        phoneCode: '+233',
        de: 'Ghana',
    },
    {
        iso: 'GI',
        phoneCode: '+350',
        de: 'Gibraltar',
    },
    {
        iso: 'GD',
        phoneCode: '+1',
        de: 'Grenada',
    },
    {
        iso: 'GR',
        phoneCode: '+30',
        de: 'Griechenland',
    },
    {
        iso: 'GL',
        phoneCode: '+299',
        de: 'Grönland',
    },
    {
        iso: 'GB',
        phoneCode: '+44',
        de: 'Großbritannien',
    },
    {
        iso: 'GP',
        phoneCode: '+590',
        de: 'Guadeloupe',
    },
    {
        iso: 'GU',
        phoneCode: '+1',
        de: 'Guam',
    },
    {
        iso: 'GT',
        phoneCode: '+502',
        de: 'Guatemala',
    },
    {
        iso: 'GG',
        phoneCode: '+44',
        de: 'Guernsey (Kanalinsel)',
    },
    {
        iso: 'GN',
        phoneCode: '+224',
        de: 'Guinea',
    },
    {
        iso: 'GW',
        phoneCode: '+245',
        de: 'Guinea-Bissau',
    },
    {
        iso: 'GY',
        phoneCode: '+592',
        de: 'Guyana',
    },
    {
        iso: 'HT',
        phoneCode: '+509',
        de: 'Haiti',
    },
    {
        iso: 'HN',
        phoneCode: '+504',
        de: 'Honduras',
    },
    {
        iso: 'HK',
        phoneCode: '+852',
        de: 'Hongkong',
    },
    {
        iso: 'IN',
        phoneCode: '+91',
        de: 'Indien',
    },
    {
        iso: 'ID',
        phoneCode: '+62',
        de: 'Indonesien',
    },
    {
        iso: 'IM',
        phoneCode: '+44',
        de: 'Isle of Man',
    },
    {
        iso: 'IQ',
        phoneCode: '+964',
        de: 'Irak',
    },
    {
        iso: 'IR',
        phoneCode: '+98',
        de: 'Iran',
    },
    {
        iso: 'IE',
        phoneCode: '+353',
        de: 'Irland',
    },
    {
        iso: 'IS',
        phoneCode: '+354',
        de: 'Island',
    },
    {
        iso: 'IL',
        phoneCode: '+972',
        de: 'Israel',
    },
    {
        iso: 'IT',
        phoneCode: '+39',
        de: 'Italien',
    },
    {
        iso: 'JM',
        phoneCode: '+1',
        de: 'Jamaika',
    },
    {
        iso: 'JP',
        phoneCode: '+81',
        de: 'Japan',
    },
    {
        iso: 'YE',
        phoneCode: '+967',
        de: 'Jemen',
    },
    {
        iso: 'JE',
        phoneCode: '+44',
        de: 'Jersey (Kanalinsel)',
    },
    {
        iso: 'JO',
        phoneCode: '+962',
        de: 'Jordanien',
    },
    {
        iso: 'KY',
        phoneCode: '+1',
        de: 'Kaimaninseln',
    },
    {
        iso: 'KH',
        phoneCode: '+855',
        de: 'Kambodscha',
    },
    {
        iso: 'CM',
        phoneCode: '+237',
        de: 'Kamerun',
    },
    {
        iso: 'CA',
        phoneCode: '+1',
        de: 'Kanada',
    },
    {
        iso: 'CV',
        phoneCode: '+238',
        de: 'Kap Verde',
    },
    {
        iso: 'KZ',
        phoneCode: '+7',
        de: 'Kasachstan',
    },
    {
        iso: 'QA',
        phoneCode: '+974',
        de: 'Katar',
    },
    {
        iso: 'KE',
        phoneCode: '+254',
        de: 'Kenia',
    },
    {
        iso: 'KG',
        phoneCode: '+996',
        de: 'Kirgisistan',
    },
    {
        iso: 'KI',
        phoneCode: '+686',
        de: 'Kiribati (Gilbertinseln)',
    },
    {
        iso: 'CC',
        phoneCode: '+61',
        de: 'Kokosinseln',
    },
    {
        iso: 'CO',
        phoneCode: '+57',
        de: 'Kolumbien',
    },
    {
        iso: 'KM',
        phoneCode: '+269',
        de: 'Komoren',
    },
    {
        iso: 'XK',
        phoneCode: '+383',
        de: 'Kosovo',
    },
    {
        iso: 'HR',
        phoneCode: '+385',
        de: 'Kroatien',
    },
    {
        iso: 'CU',
        phoneCode: '+53',
        de: 'Kuba',
    },
    {
        iso: 'KW',
        phoneCode: '+965',
        de: 'Kuwait',
    },
    {
        iso: 'LA',
        phoneCode: '+856',
        de: 'Laos',
    },
    {
        iso: 'LS',
        phoneCode: '+266',
        de: 'Lesotho',
    },
    {
        iso: 'LV',
        phoneCode: '+371',
        de: 'Lettland',
    },
    {
        iso: 'LB',
        phoneCode: '+961',
        de: 'Libanon',
    },
    {
        iso: 'LR',
        phoneCode: '+231',
        de: 'Liberia',
    },
    {
        iso: 'LY',
        phoneCode: '+218',
        de: 'Libyen',
    },
    {
        iso: 'LI',
        phoneCode: '+423',
        de: 'Liechtenstein',
    },
    {
        iso: 'LT',
        phoneCode: '+370',
        de: 'Litauen',
    },
    {
        iso: 'LU',
        phoneCode: '+352',
        de: 'Luxemburg',
    },
    {
        iso: 'MO',
        phoneCode: '+853',
        de: 'Macau',
    },
    {
        iso: 'MG',
        phoneCode: '+261',
        de: 'Madagaskar',
    },
    {
        iso: 'MW',
        phoneCode: '+265',
        de: 'Malawi',
    },
    {
        iso: 'MY',
        phoneCode: '+60',
        de: 'Malaysia',
    },
    {
        iso: 'MV',
        phoneCode: '+960',
        de: 'Malediven',
    },
    {
        iso: 'ML',
        phoneCode: '+223',
        de: 'Mali',
    },
    {
        iso: 'MT',
        phoneCode: '+356',
        de: 'Malta',
    },
    {
        iso: 'MA',
        phoneCode: '+212',
        de: 'Marokko',
    },
    {
        iso: 'MH',
        phoneCode: '+692',
        de: 'Marshallinseln',
    },
    {
        iso: 'MQ',
        phoneCode: '+596',
        de: 'Martinique',
    },
    {
        iso: 'MR',
        phoneCode: '+222',
        de: 'Mauretanien',
    },
    {
        iso: 'MU',
        phoneCode: '+230',
        de: 'Mauritius',
    },
    {
        iso: 'YT',
        phoneCode: '+262',
        de: 'Mayotte',
    },
    {
        iso: 'MX',
        phoneCode: '+52',
        de: 'Mexiko',
    },
    {
        iso: 'MD',
        phoneCode: '+373',
        de: 'Moldau',
    },
    {
        iso: 'MC',
        phoneCode: '+377',
        de: 'Monaco',
    },
    {
        iso: 'MN',
        phoneCode: '+976',
        de: 'Mongolei',
    },
    {
        iso: 'ME',
        phoneCode: '+382',
        de: 'Montenegro',
    },
    {
        iso: 'MS',
        phoneCode: '+1',
        de: 'Montserrat',
    },
    {
        iso: 'MZ',
        phoneCode: '+258',
        de: 'Mosambik',
    },
    {
        iso: 'MM',
        phoneCode: '+95',
        de: 'Myanmar',
    },
    {
        iso: 'NA',
        phoneCode: '+264',
        de: 'Namibia',
    },
    {
        iso: 'NR',
        phoneCode: '+674',
        de: 'Nauru',
    },
    {
        iso: 'NP',
        phoneCode: '+977',
        de: 'Nepal',
    },
    {
        iso: 'NC',
        phoneCode: '+687',
        de: 'Neukaledonien',
    },
    {
        iso: 'NZ',
        phoneCode: '+64',
        de: 'Neuseeland',
    },
    {
        iso: 'NI',
        phoneCode: '+505',
        de: 'Nicaragua',
    },
    {
        iso: 'NL',
        phoneCode: '+31',
        de: 'Niederlande',
    },
    {
        iso: 'NE',
        phoneCode: '+227',
        de: 'Niger',
    },
    {
        iso: 'NG',
        phoneCode: '+234',
        de: 'Nigeria',
    },
    {
        iso: 'NU',
        phoneCode: '+683',
        de: 'Niue',
    },
    {
        iso: 'MP',
        phoneCode: '+1',
        de: 'Nördliche Marianen',
    },
    {
        iso: 'KP',
        phoneCode: '+850',
        de: 'Nordkorea',
    },
    {
        iso: 'MK',
        phoneCode: '+389',
        de: 'Nordmazedonien',
    },
    {
        iso: 'NF',
        phoneCode: '+672',
        de: 'Norfolkinsel',
    },
    {
        iso: 'NO',
        phoneCode: '+47',
        de: 'Norwegen',
    },
    {
        iso: 'OM',
        phoneCode: '+968',
        de: 'Oman',
    },
    {
        iso: 'AT',
        phoneCode: '+43',
        de: 'Österreich',
    },
    {
        iso: 'TL',
        phoneCode: '+670',
        de: 'Osttimor',
    },
    {
        iso: 'PK',
        phoneCode: '+92',
        de: 'Pakistan',
    },
    {
        iso: 'PS',
        phoneCode: '+970',
        de: 'Palästina',
    },
    {
        iso: 'PW',
        phoneCode: '+680',
        de: 'Palau',
    },
    {
        iso: 'PA',
        phoneCode: '+507',
        de: 'Panama',
    },
    {
        iso: 'PG',
        phoneCode: '+675',
        de: 'Papua-Neuguinea',
    },
    {
        iso: 'PY',
        phoneCode: '+595',
        de: 'Paraguay',
    },
    {
        iso: 'PE',
        phoneCode: '+51',
        de: 'Peru',
    },
    {
        iso: 'PH',
        phoneCode: '+63',
        de: 'Philippinen',
    },
    {
        iso: 'PL',
        phoneCode: '+48',
        de: 'Polen',
    },
    {
        iso: 'PT',
        phoneCode: '+351',
        de: 'Portugal',
    },
    {
        iso: 'PR',
        phoneCode: '+1',
        de: 'Puerto Rico',
    },
    {
        iso: 'CG',
        phoneCode: '+242',
        de: 'Republik Kongo (Brazzaville)',
    },
    {
        iso: 'RE',
        phoneCode: '+262',
        de: 'Réunion',
    },
    {
        iso: 'RW',
        phoneCode: '+250',
        de: 'Ruanda',
    },
    {
        iso: 'RO',
        phoneCode: '+40',
        de: 'Rumänien',
    },
    {
        iso: 'RU',
        phoneCode: '+7',
        de: 'Russland',
    },
    {
        iso: 'PM',
        phoneCode: '+508',
        de: 'Saint-Pierre und Miquelon',
    },
    {
        iso: 'SB',
        phoneCode: '+677',
        de: 'Salomonen',
    },
    {
        iso: 'BL',
        phoneCode: '+590',
        de: 'Saint-Barthélemy',
    },
    {
        iso: 'MF',
        phoneCode: '+590',
        de: 'Saint-Martin (französischer Teil)',
    },
    {
        iso: 'ZM',
        phoneCode: '+260',
        de: 'Sambia',
    },
    {
        iso: 'WS',
        phoneCode: '+685',
        de: 'Samoa',
    },
    {
        iso: 'SM',
        phoneCode: '+378',
        de: 'San Marino',
    },
    {
        iso: 'ST',
        phoneCode: '+239',
        de: 'São Tomé und Príncipe',
    },
    {
        iso: 'SA',
        phoneCode: '+966',
        de: 'Saudi-Arabien',
    },
    {
        iso: 'SE',
        phoneCode: '+46',
        de: 'Schweden',
    },
    {
        iso: 'CH',
        phoneCode: '+41',
        de: 'Schweiz',
    },
    {
        iso: 'SN',
        phoneCode: '+221',
        de: 'Senegal',
    },
    {
        iso: 'RS',
        phoneCode: '+381',
        de: 'Serbien',
    },
    {
        iso: 'SC',
        phoneCode: '+248',
        de: 'Seychellen',
    },
    {
        iso: 'SL',
        phoneCode: '+232',
        de: 'Sierra Leone',
    },
    {
        iso: 'ZW',
        phoneCode: '+263',
        de: 'Simbabwe',
    },
    {
        iso: 'SG',
        phoneCode: '+65',
        de: 'Singapur',
    },
    {
        iso: 'SX',
        phoneCode: '+1',
        de: 'Sint Maarten',
    },
    {
        iso: 'SK',
        phoneCode: '+421',
        de: 'Slowakei',
    },
    {
        iso: 'SI',
        phoneCode: '+386',
        de: 'Slowenien',
    },
    {
        iso: 'SO',
        phoneCode: '+252',
        de: 'Somalia',
    },
    {
        iso: 'ES',
        phoneCode: '+34',
        de: 'Spanien',
    },
    {
        iso: 'LK',
        phoneCode: '+94',
        de: 'Sri Lanka',
    },
    {
        iso: 'SH',
        phoneCode: '+290',
        de: 'St. Helena',
    },
    {
        iso: 'KN',
        phoneCode: '+1',
        de: 'St. Kitts und Nevis',
    },
    {
        iso: 'LC',
        phoneCode: '+1',
        de: 'St. Lucia',
    },
    {
        iso: 'VC',
        phoneCode: '+1',
        de: 'St. Vincent und die Grenadinen',
    },
    {
        iso: 'ZA',
        phoneCode: '+27',
        de: 'Südafrika',
    },
    {
        iso: 'SD',
        phoneCode: '+249',
        de: 'Sudan',
    },
    {
        iso: 'KR',
        phoneCode: '+82',
        de: 'Südkorea',
    },
    {
        iso: 'SS',
        phoneCode: '+211',
        de: 'Südsudan',
    },
    {
        iso: 'SR',
        phoneCode: '+597',
        de: 'Suriname',
    },
    {
        iso: 'SJ',
        phoneCode: '+47',
        de: 'Spitzbergen und Jan Mayen',
    },
    {
        iso: 'SY',
        phoneCode: '+963',
        de: 'Syrien',
    },
    {
        iso: 'TJ',
        phoneCode: '+992',
        de: 'Tadschikistan',
    },
    {
        iso: 'TW',
        phoneCode: '+886',
        de: 'Taiwan',
    },
    {
        iso: 'TZ',
        phoneCode: '+255',
        de: 'Tansania',
    },
    {
        iso: 'TH',
        phoneCode: '+66',
        de: 'Thailand',
    },
    {
        iso: 'TG',
        phoneCode: '+228',
        de: 'Togo',
    },
    {
        iso: 'TK',
        phoneCode: '+690',
        de: 'Tokelau',
    },
    {
        iso: 'TO',
        phoneCode: '+676',
        de: 'Tonga',
    },
    {
        iso: 'TT',
        phoneCode: '+1',
        de: 'Trinidad und Tobago',
    },
    {
        iso: 'TA',
        phoneCode: '+290',
        de: 'Tristan da Cunha',
    },
    {
        iso: 'TD',
        phoneCode: '+235',
        de: 'Tschad',
    },
    {
        iso: 'CZ',
        phoneCode: '+420',
        de: 'Tschechien',
    },
    {
        iso: 'TN',
        phoneCode: '+216',
        de: 'Tunesien',
    },
    {
        iso: 'TR',
        phoneCode: '+90',
        de: 'Türkei',
    },
    {
        iso: 'TM',
        phoneCode: '+993',
        de: 'Turkmenistan',
    },
    {
        iso: 'TC',
        phoneCode: '+1',
        de: 'Turks- und Caicosinseln',
    },
    {
        iso: 'TV',
        phoneCode: '+688',
        de: 'Tuvalu (Ellice Islands)',
    },
    {
        iso: 'UG',
        phoneCode: '+256',
        de: 'Uganda',
    },
    {
        iso: 'UA',
        phoneCode: '+380',
        de: 'Ukraine',
    },
    {
        iso: 'HU',
        phoneCode: '+36',
        de: 'Ungarn',
    },
    {
        iso: 'UY',
        phoneCode: '+598',
        de: 'Uruguay',
    },
    {
        iso: 'US',
        phoneCode: '+1',
        de: 'USA',
    },
    {
        iso: 'UZ',
        phoneCode: '+998',
        de: 'Usbekistan',
    },
    {
        iso: 'VU',
        phoneCode: '+678',
        de: 'Vanuatu',
    },
    {
        iso: 'VA',
        phoneCode: '+39',
        de: 'Vatikanstadt',
    },
    {
        iso: 'VE',
        phoneCode: '+58',
        de: 'Venezuela',
    },
    {
        iso: 'AE',
        phoneCode: '+971',
        de: 'Vereinigte Arabische Emirate',
    },
    {
        iso: 'VN',
        phoneCode: '+84',
        de: 'Vietnam',
    },
    {
        iso: 'CN',
        phoneCode: '+86',
        de: 'Volksrepublik China',
    },
    {
        iso: 'WF',
        phoneCode: '+681',
        de: 'Wallis und Futuna',
    },
    {
        iso: 'CX',
        phoneCode: '+61',
        de: 'Weihnachtsinsel',
    },
    {
        iso: 'EH',
        phoneCode: '+212',
        de: 'Westsahara',
    },
    {
        iso: 'CF',
        phoneCode: '+236',
        de: 'Zentralafrikanische Republik',
    },
    {
        iso: 'CY',
        phoneCode: '+357',
        de: 'Zypern',
    },
];
//# sourceMappingURL=countries.js.map